import { z } from 'zod'
import { nonEmptyString } from '@my-roadtrip/validators'

const userRoleSchema = z.enum(['user', 'moderator', 'admin', 'superadmin'])
const userStatusSchema = z.enum(['active', 'suspended', 'banned'])
export const listUsersQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(50),
  cursor: nonEmptyString.optional(),
  search: nonEmptyString.optional(),
  status: z.union([userStatusSchema, z.literal('all')]).default('all')
})

export const userIdParamsSchema = z.object({
  userId: nonEmptyString
})

export const updateUserStatusSchema = z.object({
  status: userStatusSchema
})

export const updateUserRolesSchema = z.object({
  roles: z.array(userRoleSchema).min(1, 'At least one role is required')
})

const planSchema = z.object({
  id: nonEmptyString.optional(),
  name: nonEmptyString,
  tier: z.enum(['free', 'premium', 'pro'])
})

export const changeUserPlanSchema = z.object({
  plan: planSchema,
  subscriptionStatus: z
    .string()
    .trim()
    .min(1)
    .max(120)
    .nullable()
    .optional()
})

export const suspendUserSchema = z.object({
  durationDays: z.coerce.number().int().min(1).max(365),
  reason: z.string().trim().max(500).optional()
})

export const banUserSchema = z.object({
  reason: z.string().trim().max(500).optional()
})

export const resolveFlagParamsSchema = z.object({
  flagId: nonEmptyString
})

export const resolveFlagBodySchema = z.object({
  action: z.enum(['approve', 'hide', 'suspend', 'ban', 'dismiss']),
  note: z.string().trim().max(1000).optional(),
  suspendDays: z.coerce.number().int().min(1).max(365).optional()
})

export const clearCacheSchema = z.object({
  namespace: nonEmptyString.optional()
})

export const deleteCacheEntryQuerySchema = z.object({
  key: nonEmptyString
})

export const userIdOnlySchema = z.object({
  userId: nonEmptyString
})

export const auditLogsQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(200).default(100)
})

export type ListUsersQuery = z.infer<typeof listUsersQuerySchema>
export type UpdateUserStatusPayload = z.infer<typeof updateUserStatusSchema>
export type UpdateUserRolesPayload = z.infer<typeof updateUserRolesSchema>
export type ChangeUserPlanPayload = z.infer<typeof changeUserPlanSchema>
export type SuspendUserPayload = z.infer<typeof suspendUserSchema>
export type BanUserPayload = z.infer<typeof banUserSchema>
export type ResolveFlagPayload = z.infer<typeof resolveFlagBodySchema>
export type ClearCachePayload = z.infer<typeof clearCacheSchema>
export type DeleteCacheEntryQuery = z.infer<typeof deleteCacheEntryQuerySchema>
export type AuditLogsQuery = z.infer<typeof auditLogsQuerySchema>
